import React, { useState } from 'react';
import { DmsAltBox, DmsTextField, DmsSelect } from 'dmsbasereact';
import { Grid, Typography, Box, FormControlLabel, Checkbox } from '@mui/material';
import { DocumentUploadSlot } from '../../DocumentUploadSlot/DocumentUploadSlot';
import { DispensingSearch } from '../../DispensingSearch/DispensingSearch';

export const QualityReasonContainer = ({
    files,
    handleFileSelect,
    existingFiles,
    data,
    handleChange,
    fieldHasError,
    helperText,
    intl,
    searchedDispensings = [],
    setSearchedDispensings,
    dispensings = [],
}) => {
    const [wasDispensed, setWasDispensed] = useState(!!data.dispensing_pk);

    const handleWasDispensedChange = (event) => {
        const checked = event.target.checked;
        setWasDispensed(checked);
        if (!checked) {
            // Clear dispensing data when unchecked
            handleChange({ target: { name: "dispensing_pk", value: '' } });
            if (setSearchedDispensings) {
                setSearchedDispensings([]);
            }
        }
    };

    const returnDocsContainer = (
        <DmsAltBox.Card sx={{ mt: 3 }}>
            <DmsAltBox.Header>
                <Typography variant="h6">
                    {intl.get("Evidencia").d("Evidence")}
                </Typography>
            </DmsAltBox.Header>
            <DmsAltBox.Body>
                <Grid container spacing={2} alignItems="stretch">
                    <Grid item xs={12} sm={6}>
                        <DocumentUploadSlot
                            docName="evidencia"
                            file={files.evidencia}
                            onFileSelect={handleFileSelect}
                            existingFile={existingFiles.find(f => f.document_name === 'evidencia')}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <DocumentUploadSlot
                            docName="laudo"
                            file={files.laudo}
                            onFileSelect={handleFileSelect}
                            existingFile={existingFiles.find(f => f.document_name === 'laudo')}
                        />
                    </Grid>
                </Grid>
            </DmsAltBox.Body>
        </DmsAltBox.Card>
    );

    const dispensingSearchContainer = wasDispensed && setSearchedDispensings ? (
        <DmsAltBox.Card>
            <DmsAltBox.Header>
                <Typography variant="h6">
                    {intl.get("SearchDispensing").d("Search Dispensing")}
                </Typography>
            </DmsAltBox.Header>
            <DmsAltBox.Body>
                <DispensingSearch onDispensingsFound={setSearchedDispensings} />

                {searchedDispensings.length > 0 && (
                    <Box sx={{ mt: 2 }}>
                        <DmsSelect
                            label={intl.get("SelectDispensing").d("Select Dispensing")}
                            key={`dispensing-quality-${dispensings.length}`}
                            name="dispensing_pk"
                            value={data.dispensing_pk}
                            onChange={(value) => handleChange({ target: { name: "dispensing_pk", value } })}
                            options={searchedDispensings.map(disp => ({
                                value: disp.pk,
                                label: `${disp.patient_name} | ${disp.prescription_identifier} | ${disp.capsule_count} ${intl.get("Capsules").d("capsules")} | ${disp.box_count} ${intl.get("Boxes").d("boxes")} | ${disp.batch_number}`
                            }))}
                            fullWidth
                        />
                    </Box>
                )}
            </DmsAltBox.Body>
        </DmsAltBox.Card>
    ) : null;

    const returnDetailsContainer = (
        <DmsAltBox.Card>
            <DmsAltBox.Header>
                <Typography variant="h6">
                    {intl.get("returnDetails").d("Return Details")}
                </Typography>
            </DmsAltBox.Header>
            <DmsAltBox.Body>
                <Box sx={{ mt: 2 }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <DmsTextField
                                label={intl.get("QuantityOfBoxesToReturn").d("Quantity of Boxes to Return") + " *"}
                                name="quantity"
                                type="number"
                                value={data.quantity}
                                onChange={handleChange}
                                fullWidth
                                error={fieldHasError("quantity")}
                                helperText={helperText("quantity")}
                            />
                        </Grid>
                    </Grid>
                </Box>
            </DmsAltBox.Body>
        </DmsAltBox.Card>
    );

    return (
        <>
            <Box sx={{ mt: 2 }}>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={wasDispensed}
                            onChange={handleWasDispensedChange}
                        />
                    }
                    label={intl.get("WasDispensed").d("Was it dispensed?")}
                />
            </Box>
            {dispensingSearchContainer}
            {returnDocsContainer}
            {returnDetailsContainer}
        </>
    );
};
